import { render, staticRenderFns } from "./welfare-voucher-detail.vue?vue&type=template&id=8c1dc8f0&"
import script from "./welfare-voucher-detail.vue?vue&type=script&lang=js&"
export * from "./welfare-voucher-detail.vue?vue&type=script&lang=js&"
import style0 from "./welfare-voucher-detail.vue?vue&type=style&index=0&scopde=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports